import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { formatCurrency } from '../../../lib/formatters';
import { pi4Confirm } from '../../../actions/sessions';
import Loading from '../../shared/Loading';

export default function Conversion() {
  const dispatch = useDispatch();
  const history = useHistory();
  const cart = useSessionEntity('shopping_cart');
  const merchant = useSessionEntity('merchant');
  const user = useSessionEntity('user');

  const cancel = () => window.location.href = merchant.url;

  const next = () => { 
    dispatch(pi4Confirm());
    return history.push('/init/new_user'); 
  }

  if (!user && !cart) return <Loading active={true} />

  return <div id="content" className="has-text-centered">
    <div className="title">Hi, {user.first_name}</div>

    <div className="mb-3">You’re approved for Credit Key’s Pay in 4{cart ? <span>, but this <strong>{formatCurrency(cart.grand_total)}</strong> purchase requires a Credit Key Business approval.</span> : '.'} This is a separate application process.</div>
    <div className="mb-3">Get approved for Credit Key Business in less than 5 minutes, with credit up to $50k and terms as long as 12 months.</div>
    <div className="mb-6">If you don’t have a business, or don’t want to apply, you can continue to use Pay in 4 for smaller purchases.</div>

    <div className="columns">
      <div className="column is-half">
        <button className="button is-fullwidth has-text-weight-bold" onClick={cancel}>Cancel</button>
      </div>
      <div className="column is-half">
        <button className="button is-fullwidth is-primary has-text-weight-bold" onClick={next}>Continue</button>
      </div>
    </div>
  </div>;
}
